const ToggleSwitch = ({ onClick, id = "", checked }) => {
	return (
		<div className="toggle-switch">
			<label className={`toggle ${id}`}>
				<div className="toggle__wrapper">
					<input
						aria-hidden="true"
						type="checkbox"
						tabIndex={-1}
						id={id}
						checked={checked}
						onChange={() => {}}
					/>
					<div
						className="toggle__bg"
						onClick={(e: React.MouseEvent<HTMLDivElement>) => {
							if (onClick) onClick(e);
						}}
					>
						<div className="toggle__sphere">
							<div className="toggle__sphere-bg" />
							<div className="toggle__sphere-overlay" />
						</div>
					</div>
				</div>
			</label>
		</div>
	);
};

export default ToggleSwitch;
